export default __webpack_public_path__ + "static/media/logo-sm.e6b5376d.png";